import FaqSection from '@/v2/components/sections/common/faq-section'
import ForWhoSection from '@/v2/components/sections/common/for-who-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PartnersSection from '@/v2/components/sections/common/partners-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  faqSectionContent,
  forWhoSectionContent,
  heroSectionContent,
  howOurInternationalShippingServicesWork,
  keyFactorsAffectingSectionContent,
  partnersSectionContent,
  promotionalBannerSectionContent,
  whyChooseUsSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/international-shipping-services-page'

interface InternationalShippingServicesPageProps {}

const InternationalShippingServicesPage: React.FC<InternationalShippingServicesPageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName='
        w-[350px] h-[197px]
        lg:!w-[527px] lg:h-[297px]
        xl-min:!w-[638px] xl-min:h-[459.18px]
      '
        btnClassName='xl-min:!w-[234px] lg-mn:w-[277px] xl-min:h-[50px] md-mn:w-[276px] w-[278px] h-[44px]'
        className='[&_p]:max-w-[350px] [&_p]:md-mn:max-w-full'
      />
      <ServiceTipsSectionSection
        isBgDark
        {...howOurInternationalShippingServicesWork}
        className={`
          [&>div>div:nth-of-type(2)]:md-mn:grid-cols-3
          [&_article]:text-center
          [&_article_div]:w-full
          [&_h3]:text-center
          xl-min:[&_button]:!w-[266px]
          [&_button]:w-[278px]
          `}
      />
      <ServiceTipsSectionSection {...whyChooseUsSectionContent} />
      <WhyWeSection isBgDark {...whyWeSectionContent} />
      <PartnersSection {...partnersSectionContent} />
      <HelperSection
        isBgDark
        {...keyFactorsAffectingSectionContent}
        buttonClassName='lg-mn:w-[301px] md-mn:w-[244px] w-[278px]'
        imgClassName='w-[344px] h-[215px] md-mn:w-[344px] md-mn:h-[215px] xl-min:!h-[387px] xl-min:!w-[618px]'
      />
      <ForWhoSection {...forWhoSectionContent} />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        className='xl-min:[&_button]:!w-[259px] md-mn:[&_button]:w-[244px] [&_button]:w-[230px]'
      />
      <FaqSection {...faqSectionContent} isBgDark />
    </>
  )
}

export default InternationalShippingServicesPage
